import React from 'react';
import '../css/components/Spinner.css';

export default function Spinner(props) {

	return (
		<aside className='wrapper-spinner overlay_spinner'>
			<div aria-hidden="true" className='md:w-16 w-12'>
				<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 240 240">
					<path className="progress stela" d="M0-108c-59.6 0-108 48.4-108 108c0 59.6 48.4 108 108 108c59.6 0 108-48.4 108-108c0-59.6-48.4-108-108-108Z"></path>
					<path className="progress flash" d="M0-108c-59.6 0-108 48.4-108 108c0 59.6 48.4 108 108 108c59.6 0 108-48.4 108-108c0-59.6-48.4-108-108-108Z"></path>
					<path className="lead-dot" d="M0-12c6.6 0 12 5.4 12 12c0 6.6-5.4 12-12 12c-6.6 0-12-5.4-12-12c0-6.6 5.4-12 12-12Z"></path>
				</svg>
			</div>
			<p className='font-bbvaMedium text-2xl text-center'>{props.mensaje}</p>
			<span className="sr-only"><slot></slot></span>
		</aside>
	);
};